// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:52:28

export default {
  "id": "sprunki-puzzles-and-singing",
  "slug": "sprunki-puzzles-and-singing",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/778d6c33d39042e382b9146d1937eafa-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/778d6c33d39042e382b9146d1937eafa/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki Puzzles and Singing",
      "description": "Before the sprunks take on their immediate duties, namely creating music, you must unlock sixteen characters. In the meantime, you have no one to create your own melodies with. To bring the Sprunki back to life, you must collect an image of each Sprunki. The picture consists of nine square fragments that are mixed on the playing field. Swap them and install them in the correct positions. Having collected all the puzzles, you can start making music in Sprunki Puzzles and Singing.",
      "instructions": "Use your mouse or tap the screen.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "music",
        "skill",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "水花拼图与歌唱",
      "description": "在Sprunks开始他们的直接任务，即创作音乐之前，你必须解锁十六个角色。在此期间，你没有人可以与你一起创作旋律。为了使Sprunki复活，你必须收集每个Sprunki的图像。这张图片由九个方块碎片组成，它们在游戏场地上混合。交换它们并安装到正确的位置。收集所有拼图后，你就可以在Sprunki Puzzles and Singing中开始创作音乐了。",
      "instructions": "使用鼠标或轻触屏幕。",
      "genres": [
        "休闲",
        "解谜"
      ],
      "tags": [
        "1玩家",
        "音乐",
        "技能",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "湯姆拼圖與歌唱",
      "description": "在 Sprunks 承擔他們即將的職責，即創作音樂之前，您必須解鎖十六個角色。在此之間，您沒有人與您一起創作自己的旋律。為了讓 Sprunki 复活，您必須收集每個 Sprunki 的圖片。這張圖片由九個方塊碎片組成，在遊戲場地上混合。交換它們並將它們安裝在正確的位置。收集完所有謎題後，您就可以在 Sprunki Puzzles and Singing 中開始創作音樂了。",
      "instructions": "使用您的滑鼠或觸控螢幕。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1 玩家",
        "音樂",
        "技巧",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "Sprunki 輪盤遊戲 及 歌唱",
      "description": "在Sprunks展開他們即將的職責，即創作音樂之前，你必須解鎖十六個角色。在此之間，你沒有人可以跟你一起創作自己的旋律。要讓Sprunki恢復活力，你必须收集每個Sprunki的圖片。這張圖片由九個方形碎片組成，在遊戲場上混雜。交換它們並將它們安裝在正確的位置。收集完所有謎題後，你就可以在Sprunki Puzzles and Singing中開始創作音樂了。",
      "instructions": "使用鼠標或輕觸螢幕。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "音樂",
        "技能",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "スプリンキー・パズルズと歌う",
      "description": "スプリンクスが音楽を作る役割を引き受ける前に、つまり音楽を作る役割を引き受ける前に、16人のキャラクターを解放する必要があります。その間、あなた自身のメロディを作るために誰もいません。スプリンクスを蘇らせるために、各スプリンクスの画像を収集する必要があります。この画像は、プレイフィールド上で混ざり合った九つの四角形のピースで構成されています。それらを交換し、正しい位置にインストールします。すべてのパズルを収集した後、スプリンクスパズルと歌いながら音楽を作り始めることができます。",
      "instructions": "マウスを使用したり、スクリーンをタップしてください。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "音楽",
        "スキル",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "스프런키 퍼즐과 노래",
      "description": "스프런키들이 음악을 만드는 직책을 시작하기 전에, 즉음해 16명의 캐릭터를 해금해야 합니다. 그 동안 자신만의 멜로디를 만들 수 있는 사람이 없습니다. 스프런키를 다시 살리기 위해 각 스프런키의 이미지를 모아야 합니다. 그림은 플레이 필드에서 혼합된 나선형으로 구성된 9개의 정方形 조각입니다. 그들을 교환하고 올바른 위치에 설치하세요. 모든 퍼즐을 모았다면, 스프런키 퍼즐 및 노래에서 음악을 만들 수 시작합니다.",
      "instructions": "마우스를 사용하거나 화면을 탭하세요.",
      "genres": [
        "캐주얼",
        "패자드림"
      ],
      "tags": [
        "1플레이어",
        "음악",
        "기술",
        "슬라이딩 퍼즐"
      ]
    },
    "fr": {
      "title": "Puzzles Sprunki et Chantant",
      "description": "Avant que les Sprunks ne s'acquittent de leurs tâches immédiates, à savoir créer de la musique, vous devez déverrouiller seize personnages. En attendant, vous n'avez personne pour créer vos propres mélodies. Pour ramener les Sprunki à la vie, vous devez collecter une image de chaque Sprunki. L'image se compose de neuf fragments carrés qui sont mélangés sur le terrain de jeu. Échangez-les et installez-les dans les positions correctes. Une fois tous les puzzles collectés, vous pouvez commencer à faire de la musique dans Sprunki Puzzles and Singing.",
      "instructions": "Utilisez votre souris ou appuyez sur l'écran.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "musique",
        "compétence",
        "puzzle glissant"
      ]
    }
  }
};
